import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { responsive } from "buoy-theme"
import {
  Page,
  PAGE_TOP_MARGIN,
  BreadCrumbContainer,
  Content as DefaultContent,
} from "./Page"
import { HeadingOne, Paragraph, Button } from "buoy-core"
import { ButtonRow } from "./ButtonRow"
import BreadcrumbNav from "./BreadcrumbNav"
import { samlHandoff } from "../actions"
import tracker from "../../common/tracker"

export const Content = styled(DefaultContent)`
  align-items: center;
  ${responsive(
    "justify-content",
    "initial",
    "initial",
    "initial",
    "initial",
    "space-between"
  )};
  /* Subtracted value is the top margin of the Page component */
  height: calc(100vh - ${PAGE_TOP_MARGIN} - 30px);

  h1 {
    ${responsive(
      "margin",
      "140px 0 24px",
      "140px 0 24px",
      "140px 0 24px",
      "140px 0 24px",
      "68px 0 24px"
    )};
    text-align: center;
  }

  p {
    max-width: 480px;
    margin-bottom: 40px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${responsive("text-align", "center", "center", "center", "center", "left")};
`

const Submit = ({ seconds, samlHandoff }) => (
  <Page>
    <BreadCrumbContainer>
      <BreadcrumbNav />
      <Content>
        <TextContent>
          <HeadingOne>Order confirmed.</HeadingOne>
          <Paragraph>
            Redirecting you to Buoy LIVE in {seconds}
          </Paragraph>
        </TextContent>
        <ButtonRow>
          <Button onClick={samlHandoff}>Start</Button>
        </ButtonRow>
      </Content>
    </BreadCrumbContainer>
  </Page>
)

class SubmitContainer extends React.Component {
  state = { seconds: 5 }

  componentDidMount() {
    tracker.paymentSubmitPageLoaded()
    const timer = setInterval(() => {
      this.setState({ seconds: this.state.seconds - 1 })
      if (this.state.seconds === 0) {
        clearInterval(timer)
        this.props.samlHandoff()
      }
    }, 1000)
  }

  render() {
    return <Submit {...this.props} {...this.state} />
  }
}

const mapDispatchToProps = dispatch => ({
  samlHandoff: () => dispatch(samlHandoff()),
})

const SubmitWrapper = connect(null, mapDispatchToProps)(SubmitContainer)

export {SubmitWrapper as default, Submit}



// WEBPACK FOOTER //
// ./assets/payment/components/Submit.js